import React, { useLayoutEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import SunbaeBriefingCenterPc from './designcomponents/sunbaebriefingcenterpc';
import SunbaeBriefingCenterMobile from './designcomponents/sunbaebriefingcentermobile';

export default function SunbaeBriefingCenter() {
  useLayoutEffect(() => { window.scrollTo(0, 0); }, []);
  const isMobile = useMediaQuery({ query: '(max-width: 1024px)' });
  return isMobile ? <SunbaeBriefingCenterMobile /> : <SunbaeBriefingCenterPc />;
}
